module.exports = __webpack_public_path__ + "assets/img/shop_bady.05d5e546.png";